<template>
  <!-- eslint-disable -->
  <div v-if="match !== undefined && match != null" class="statistics-form a-vs-b--statistics-wrap__form">
    <statistics-oponnents
      :awayTeam="match.AwayTeam"
      :awayTeamLogo="match.AwayTeamLogo"
      :awayTeamShort="match.AwayTeamShort"
      :homeTeam="match.HomeTeam"
      :homeTeamLogo="match.HomeTeamLogo"
      :homeTeamShort="match.HomeTeamShort"
      :componentTitle="componentTitle"
      :componentSubtitle="componentSubtitle" />

    <div class="a-vs-b-card-content">
      <div class="a-vs-c--card-statistics__host">
        <percentage-bar
          :teamForm="formData.FirstTeamForm"
          :teamClass="formData.FirstTeamClass"
          :teamColorClass="'a-vs-f-success-secondary'"/>

        <rating-bottom 
          :winsTeam="formData.WinsFirstTeam"
          :teamGoalsHomeTeam="formData.FirstTeamGoalsHomeTeam"
          :teamGoalsAwayTeam="formData.FirstTeamGoalsAwayTeam"
          :teamPlayedHome="formData.FirstTeamPlayedHome"/>
      </div>

      <div class="a-vs-c--card-statistics__guest">
        
        <percentage-bar
          :teamForm="formData.SecondTeamForm"
          :teamClass="formData.SecondTeamClass"
          :teamColorClass="'a-vs-f-danger-secondary'"/>
        
        <rating-bottom 
          :winsTeam="formData.WinsSecondTeam"
          :teamGoalsHomeTeam="formData.SecondTeamGoalsHomeTeam"
          :teamGoalsAwayTeam="formData.SecondTeamGoalsAwayTeam"
          :teamPlayedHome="formData.SecondTeamPlayedHome"/>
      </div>
    </div>
  </div>
</template>
<script>
import RatingBottom from '@/components/soccer/statistics/RatingBottom.vue'
import PercentageBar from '@/components/soccer/statistics/PercentageBar.vue'

export default {
  components: {
    'rating-bottom': RatingBottom,
    'percentage-bar': PercentageBar
  },
  props: {
    componentTitle: {
      type: String
    },
    componentSubtitle: {
      type: String
    },
    eventData: {
      type: Object,
      required: false
    }
  },
  methods: {
    populateStatistics (formData) {
      let FirstTeamClass = []
      let SecondTeamClass = []
      for (var index = 1; index <= 20; index++) {
        FirstTeamClass[index] = index * 5 <= formData.FirstTeamForm
        SecondTeamClass[index] = index * 5 <= formData.SecondTeamForm
      }
      this.eventData.Matches[0].Stats.Form.FirstTeamClass = []
      this.eventData.Matches[0].Stats.Form.SecondTeamClass = []

      this.eventData.Matches[0].Stats.Form.FirstTeamClass.push(FirstTeamClass)
      this.eventData.Matches[0].Stats.Form.SecondTeamClass.push(SecondTeamClass)
    }
  },
  computed: {
    match: function () {
      if (this.eventData != null) {
        return this.eventData.Matches[0]
      } else {
        return null
      }
    },
    formData: function () {
      if (this.eventData != null) {
        this.populateStatistics(this.eventData.Matches[0].Stats.Form)
        return this.eventData.Matches[0].Stats.Form
      } else {
        return null
      }
    }
  }
}
</script>
